import { login, logout, getInfo } from '@/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'
import db from '@/utils/localstorage' //导入持久化缓存工具
import config from '@/utils/config';
const user = {
    state: {
        token: db.get('token') || '',
        name: '',
        id: '',
        avatar: '',
        roles: [],
        permissions: [],
        userInfo: '',
        company: "",
        fullscreen: false,
        showWater: false, // 水系统
        showVideo: true, // 视频

    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_ID: (state, id) => {
            state.id = id
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        },
        SET_USER: (state, payload) => {
            state.userInfo = payload
            // console.log(state.userInfo, payload)
        },
        SET_COMPANY: (state, pay) => {
            log(pay, 1232321)
            state.company = pay
        },
        // 全屏
        SET_FULLSCREEN: (state, fullscreen) => {
            state.fullscreen = fullscreen
        },
        getWaterModel: (state) => {
            state.showWater = true
            state.showVideo = false
        },

        getVideoModel: (state) => {
            state.showWater = false
            state.showVideo = true
        },



    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {

            const username = userInfo.username.trim()
            const password = userInfo.password
            const code = userInfo.code
            const uuid = userInfo.uuid
            return new Promise((resolve, reject) => {
                login(username, password).then(res => {
                    log(res, 5555555555555)

                    // setToken(res.data.token)
                    commit('SET_TOKEN', res.data.token)
                    // db.save('userInfo',data)
                    db.save('token', res.data.token)
                    // commit('saveUser',res.data)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {

                getInfo(state.token).then(res => {
                    log(res, 123456)

                    const user = res.data.user
                    // user.isWenwu = window.location.host.indexOf('wenwu') > -1

                    // user.tongxin = window.location.host.indexOf('tongxin') > -1
                    // if (process.env.NODE_ENV == "development") {
                    // }
                    // 上线注销
                    // user.isWenwu = true
                    // user.tongxin = true



                    // const avatar = user.avatar == "" ? require("@/assets/image/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
                    if (res.data.roles && res.data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.data.roles)
                        commit('SET_PERMISSIONS', res.data.permissions)
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_NAME', user.userName)
                    // commit('SET_AVATAR', avatar)
                    commit('SET_ID', user.userId)
                    commit('SET_USER', user)
                    // commit('SET_WEATHER', user.region)
                    // log(user.region, 1)
                    // console.log(user.region, '地区')
                    if (res.data.companyBase) {
                        commit('SET_COMPANY', res.data.companyBase)
                    }
                    db.save('userInfo', user)
                    resolve(res.data)
                }).catch(error => {
                    reject(error)
                })
            })
            // return new Promise((resolve, reject) => {

            //     var res = {"code":200,"success":true,"data":{"user":{"searchValue":null,"createBy":"admin","createTime":"2022-03-30 09:48:30","updateBy":null,"updateTime":null,"remark":"管理员","params":{},"userId":"1","userIdStr":"1","deptId":103,"userName":"admin","nickName":"若依","email":"ry@163.com","phonenumber":"15888888888","sex":"1","avatar":"","password":"$2a$10$YAukxyqOpZ8Do.GGwaSmGOA/40ORnM3lpuQfjKAujVHs2RuyrB.MS","salt":null,"status":"1","delFlag":"0","loginIp":"127.0.0.1","loginDate":"2022-03-30T09:48:30.000+0800","dept":{"searchValue":null,"createBy":null,"createTime":null,"updateBy":null,"updateTime":null,"remark":null,"params":{},"deptId":103,"parentId":101,"ancestors":null,"deptName":"研发部门","orderNum":"1","leader":"若依","phone":null,"email":null,"status":"0","delFlag":null,"parentName":null,"children":[]},"roles":[{"searchValue":null,"createBy":null,"createTime":null,"updateBy":null,"updateTime":null,"remark":null,"params":{},"roleId":3,"roleName":"集团角色","roleKey":"1","roleSort":"0","dataScope":"1","menuCheckStrictly":false,"deptCheckStrictly":false,"status":"0","delFlag":null,"flag":false,"menuIds":null,"deptIds":null,"admin":false},{"searchValue":null,"createBy":null,"createTime":null,"updateBy":null,"updateTime":null,"remark":null,"params":{},"roleId":4,"roleName":"园区角色","roleKey":"2","roleSort":"0","dataScope":"1","menuCheckStrictly":false,"deptCheckStrictly":false,"status":"0","delFlag":null,"flag":false,"menuIds":null,"deptIds":null,"admin":false}],"roleIds":null,"postIds":null,"natureId":null,"natureName":null,"industryCode":null,"industryName":null,"roleId":null,"roleName":"集团角色","province":null,"city":null,"area":null,"affiliatedUnit":null,"regulatoryUnit":null,"admin":true},"permissions":["*:*:*"],"roles":["admin"]},"msg":"操作成功"}
            //     const user = res.data.user

            //     if (res.data.roles && res.data.roles.length > 0) { 
            // 验证返回的roles是否是一个非空数组
            //         commit('SET_ROLES', res.data.roles)
            //         commit('SET_PERMISSIONS', res.data.permissions)

            //     } else {
            //         commit('SET_ROLES', ['ROLE_DEFAULT'])
            //     }
            //     const avatar = user.avatar
            //     commit('SET_NAME', user.userName)
            //     commit('SET_AVATAR', avatar)
            //     commit('SET_ID', user.userId)
            //     console.log(res )
            //     resolve(res.data)
            //     if(!res){
            //     reject(null)

            //     }
            // })
        },

        // 退出系统
        LogOut({ commit, state }) {
            // console.log(config.apiUrl);
            let jumpLocation = localStorage.getItem("jumpLocation");
            console.log(navigator.userAgent);
            if (jumpLocation) {
                db.remove('jumpLocation')
                window.close()
            }
                         
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    console.log(state)
                    // if (state.userInfo.tongxin) {
                    //     commit("setFavicon", './logo.ico');
                    //     commit('setTitle', '同信智能')
                    // }
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    commit('SET_USER', "")
                    commit('SET_COMPANY', '')
                    // removeToken()
                    db.remove('userInfo')
                    db.remove('token')
                    db.remove('bjList')
                    db.remove('company')
                    db.remove('otherBjList')
                    if (jumpLocation) {
                        db.remove('jumpLocation')
                        window.close()
                    }
                   
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getWaterModel({ commit }, status) {
            commit('showWaterModel', status)
        },

        getVideoModel({ commit }, status) {
            commit('showWaterModel', status)
        }
        // 前端 登出
        // FedLogOut({ commit }) {
        //     return new Promise(resolve => {
        //         commit('SET_TOKEN', '')
        //         removeToken()
        //         resolve()
        //     })
        // }
    }
}

export default user